export default "__VITE_ASSET__BKlcvUAX__"